import DevelopmentCard from "./DevelopmentCard";

export default DevelopmentCard;
export type { DevelopmentCardData } from "./types";
